import React, { useState, useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import { requestForToken, onMessageListener } from "./libs/firebase";
import Welcome from "./pages/Welcome/Welcome";
import Join from "./pages/Join/Join";
import Main from "./pages/Main/Main";
import FindAccount from "./pages/FindAccount/FindAccount";
import TreatmentList from "./pages/TreatmentList/TreatmentList";
import MyReservation from "./pages/MyReservation/MyReservation";
import TreatmentDetail from "./pages/TreatmentDetail/TreatmentDetail";
import ClinicDetail from "./pages/ClinicDetail/ClinicDetail";
import MyPage from "./pages/MyPage/MyPage";
import EventReview from "./pages/EventReview/EventReview";
import MobileNavigation from "./components/MobileNavigation/MobileNavigation";
import CompanyInfo from "./pages/CompanyInfo/CompanyInfo";
import Terms from "./pages/Terms/Terms";
import Guide from "./pages/Guide/Guide";
import UnauthorizedEmailCollection from "./pages/UnauthorizedEmailCollection/UnauthorizedEmailCollection";
import Privacy from "./pages/Privacy/Privacy";
import ResetPw from "./pages/ResetPw/ResetPw";
import Order from "./pages/Order/Order";
import OrderSuccess from "./pages/OrderSuccess/OrderSuccess";
import CommercialTransactions from "./pages/CommercialTransactions/CommercialTransactions";
import Google from './auth/Google';
import Line from "./auth/Line";

function App() {
  const [isMobile, setIsMobile] = useState(false);
  const [fcmToken, setFcmToken] = useState<string | null>(null);
  const [notification, setNotification] = useState<any>(null);

  useEffect(() => {
    const updateIsMobile = () => {
      setIsMobile(window.matchMedia("(max-width: 768px)").matches);
    };
  
    updateIsMobile();
    window.addEventListener("resize", updateIsMobile);
    
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then((registration) => {
          console.log("Service Worker registered with scope:", registration.scope);
        })
        .catch((err) => {
          console.error("Service Worker registration failed:", err);
        });
    }
  
    const requestToken = async () => {
      try {
        const token = await requestForToken();
        if (token) {
          console.log("FCM Token received:", token);
          setFcmToken(token);
        }
      } catch (error) {
        console.error("Error fetching FCM token:", error);
      }
    };
  
    requestToken();
  
    const unsubscribe = onMessageListener()
      .then((payload) => {
        console.log("Foreground message received:", payload);
        setNotification(payload);
      })
      .catch((err) => console.error("Error listening for messages:", err));
  
    return () => window.removeEventListener("resize", updateIsMobile);
  }, []);
  

  return (
    <BrowserRouter>
      <AppRoutes isMobile={isMobile} fcmToken={fcmToken}/>
    </BrowserRouter>
  );
}

function AppRoutes({ isMobile, fcmToken }: { isMobile: boolean, fcmToken: string | null; }) {
  const location = useLocation();
  const hideMobileNavigationPaths = ["/login", "/join", "/findAccount"];
  const shouldShowMobileNavigation = !hideMobileNavigationPaths.includes(location.pathname);

  return (
    <>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route
          path="/login"
          element={<Welcome fcmToken={fcmToken} />}
        />
        <Route path="/join" element={<Join />} />
        <Route path="/findAccount" element={<FindAccount />} />
        <Route path="/treatment-list" element={<TreatmentList />} />
        <Route path="/my-reservation" element={<MyReservation />} />
        <Route path="/treatment-detail/:id" element={<TreatmentDetail />} />
        <Route path="/clinic-detail/:hospital_id" element={<ClinicDetail />} />
        <Route path="/myPage" element={<MyPage />} />
        <Route path="/event-review/:hospital_id/:product_id" element={<EventReview />} />
        <Route path="/companyInfo" element={<CompanyInfo />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/guide" element={<Guide />} />
        <Route path="/unauthorizedEmailCollection" element={<UnauthorizedEmailCollection />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/resetPw" element={<ResetPw />} />
        <Route path="/order" element={<Order />} />
        <Route path="/order/success" element={<OrderSuccess />} />
        <Route path="/auth/google/callback" element={<Google />} />
        <Route path="/auth/line/callback" element={<Line />} />
        <Route path="/commercial-transactions" element={<CommercialTransactions />} />
      </Routes>
      {isMobile && shouldShowMobileNavigation && <MobileNavigation />}
    </>
  );
}

export default App;
